module.exports = __webpack_public_path__ + "static/media/product-1.adc49245.png";